import { Action } from 'redux';

import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { OpenManageItemsInCollectionsDialog } from '../../AppActionTypes';
import { ManageItemsTelemetry, initialManageItemsTelemetry } from '../../../spaces/Collections/CollectionsTelemetry';

export interface ManageItemsInCollectionsDialogAction extends Action {
  targetItems: IContentInfo[];
  targetCollectionLuids?: string[];
  manageItemsTelemetry: ManageItemsTelemetry;
}

export function openManageItemsInCollectionsDialogAction(
  targetItems: IContentInfo[],
  targetCollectionLuids?: string[],
  manageItemsTelemetry?: ManageItemsTelemetry
): ManageItemsInCollectionsDialogAction {
  return {
    type: OpenManageItemsInCollectionsDialog,
    targetItems,
    targetCollectionLuids,
    manageItemsTelemetry: manageItemsTelemetry || initialManageItemsTelemetry()
  };
}
